<template>
  <div class="TopHeader">
    <div>
      <a class="logo_L" href="//wap.qianlima.com/"
        ><img src="//gw-static.qianlima.com/0cdn/static/front/qlmBidding_static_template/img/wap/logo.png"
      /></a>
    </div>
    <div class="TopHeader-right" v-if="!username">
      <a href="https://zxhy.qianlima.com/qlmWechat/wechatPage/login.html" target="_self" class="login_btn left_btn"
        >登录</a
      >
      <a href="//wap.qianlima.com/register.jsp" target="_self" class="login_btn right_btn">注册</a>
    </div>
    <div class="TopHeader-right user-box" v-if="username">
      <div>欢迎您</div>
      <div class="user-box-item">
        <span>{{ username }}</span>
        <span class="loginOut">[退出]</span>
      </div>
    </div>
  </div>
</template>

<script>
import { clearCookies } from "@/utils/common";

export default {
  name: "TopHeader",
  components: {},
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.getters["wapGjxx/userInfo"];
    },
    username() {
      return this.userInfo.username;
    },
  },
  methods: {
    loginOut() {
      clearCookies();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
.TopHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  // height: 50px;
  background-color: #fff;
  .logo_L {
    display: block;
    width: 194px;
    height: 44px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .TopHeader-right {
    display: flex;
    a {
      display: block;
      height: 28px;
      width: 50px;
      line-height: 28px;
      vertical-align: middle;
      color: #fff;
      background: #ff8207;
      text-align: center;
      border-radius: 3px;
      cursor: pointer;
      margin-left: 10px;
      font-size: 12px;
    }
  }
  .user-box {
    flex-wrap: wrap;
    justify-content: flex-end;
    .user-box-item {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      color: #e60012;
      .loginOut {
        padding-left: 5px;
        color: #1687ff;
      }
    }
  }
}
</style>
